export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '08854209-bee0-430f-93ea-dbead04286a1';
export const MODAL_CLOSE_SEC = 2.5;
